
export interface DocumentsCompressionConfiguration {
    collections?: string[];
    compressRevisions?: boolean;
    compressAllCollections?: boolean;
}
